import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, where, Timestamp } from "firebase/firestore";
import { db } from "./firebaseConfig";

const BUG_REPORTS_COLLECTION = "bug_reports";

export type BugReportStatus = 'open' | 'resolved';

export interface BugReportData {
  title: string;
  description: string;
  stepsToReproduce: string;
  page: string;
  imageUrl: string | null;
  imagePath: string | null;
  reportedBy: string;
  reportedByUsername: string;
  userAgent: string;
  currentUrl: string;
  status: BugReportStatus;
  createdAt: Timestamp;
  resolvedAt: Timestamp | null;
}

export type SavedBugReport = BugReportData & { id: string };

export async function submitBugReport(data: {
  title: string;
  description: string;
  stepsToReproduce: string;
  page: string;
  reportedBy: string;
  reportedByUsername: string;
  userAgent: string;
  currentUrl: string;
}): Promise<string> {
  const reportData: BugReportData = {
    ...data,
    imageUrl: null,
    imagePath: null,
    status: 'open',
    createdAt: Timestamp.now(),
    resolvedAt: null,
  };

  const docRef = await addDoc(collection(db, BUG_REPORTS_COLLECTION), reportData);
  return docRef.id;
}

export async function getBugReports(statusFilter?: BugReportStatus): Promise<SavedBugReport[]> {
  const q = statusFilter
    ? query(collection(db, BUG_REPORTS_COLLECTION), where("status", "==", statusFilter))
    : query(collection(db, BUG_REPORTS_COLLECTION));

  const snapshot = await getDocs(q);
  const reports = snapshot.docs.map(d => ({ id: d.id, ...d.data() } as SavedBugReport));
  // Sort client-side to avoid needing a Firestore composite index
  return reports.sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis());
}

export async function resolveBugReport(id: string): Promise<void> {
  const docRef = doc(db, BUG_REPORTS_COLLECTION, id);
  await updateDoc(docRef, { status: 'resolved', resolvedAt: Timestamp.now() });
}

export async function deleteBugReport(report: SavedBugReport): Promise<void> {
  await deleteDoc(doc(db, BUG_REPORTS_COLLECTION, report.id));
}
